import * as React from 'react';
import styled from 'styled-components';

import { fontWeights } from '../../ui/inline-styles/variables';
import { Changer, CoreChangerEntity } from '../models/core-changer.model';

interface Props {
  coreChanger: CoreChangerEntity;
  children: React.ReactNode;
}

const StCoreChangerButton = styled.a`
  padding: 4px 8px;
  opacity: 0.25;
  font-size: 1.5rem;
  font-weight: ${fontWeights.regular};
  color: #ffffff;
  cursor: pointer;
  transition: opacity 0.3s ease-out;
  & + & {
    margin-left: 16px;
  }
  &:hover {
    opacity: 0.5;
  }
`;

class CoreChangerButton extends React.Component<Props> {
  onClick = (changers: Changer[]): void => {
    const promptResults: Array<string | null> = changers.map((changer: Changer) =>
      prompt(
        changer.copy,
        localStorage.getItem(changer.localStorageKey) ? `${localStorage.getItem(changer.localStorageKey)}` : ''
      )
    );

    const areAllPromptsCanceled: boolean = promptResults.every((promptResult: string | null) => promptResult === null);

    if (
      !areAllPromptsCanceled &&
      confirm('Your webpage will refresh to apply this change.\nDo you want to refresh now?')
    ) {
      changers.forEach((changer: Changer, index: number) => {
        localStorage.setItem(changer.localStorageKey, promptResults[index] !== null ? `${promptResults[index]}` : '');
      });
      location.reload();
    }
  };

  render() {
    const { coreChanger, children } = this.props;

    return (
      <StCoreChangerButton onClick={() => this.onClick(coreChanger.changers)} title={coreChanger.name}>
        {children}
      </StCoreChangerButton>
    );
  }
}

export default CoreChangerButton;



// WEBPACK FOOTER //
// ./src/app/dashboard/components/CoreChangerButton.tsx